import React,{useContext}from "react";
import { ShopContext } from "../Context/ShopContext";
import { useParams } from "react-router-dom";
import ProductPage from "../Components/ProductPage/ProductPage";

const Product = ()=>{
    const {all_product} = useContext(ShopContext);
    const {productId}=useParams()
    const product = all_product.find((a)=>a.id=== Number(productId))
    return(
        <>
            <ProductPage product={product}/>
        </>
    )
}

export default Product;